import { differenceInCalendarDays, isPast, isToday, isTomorrow } from "date-fns";

const getFooterMessage = (isDelivered: boolean, eddEpoch: number, t: (key: string) => string) => {
    if (isDelivered) {
        return t("rttv_widget_status_delivered");
    }
    else if (eddEpoch === 0) {
        return "---";
    }
    else if (isPast(eddEpoch)) {
        return t("rttv_widget_delayed");
    }
    else if (isToday(eddEpoch)) {
        return t("rttv_widget_delivery_today");
    }
    else if (isTomorrow(eddEpoch)) {
        return `${t("rttv_widget_delivery_in")} 1 ${t("rttv_widget_day")}`;
    }
    return `${t("rttv_widget_delivery_in")}  ${differenceInCalendarDays(new Date(Number(eddEpoch)), new Date())}  ${t("rttv_widget_days")}`;
};

export default getFooterMessage;
